import { render, staticRenderFns } from "./ProductQuestion.vue?vue&type=template&id=f99d1e92&scoped=true"
import script from "./ProductQuestion.vue?vue&type=script&lang=js"
export * from "./ProductQuestion.vue?vue&type=script&lang=js"
import style0 from "./ProductQuestion.vue?vue&type=style&index=0&id=f99d1e92&prod&scoped=true&lang=css"
import style1 from "./ProductQuestion.vue?vue&type=style&index=1&id=f99d1e92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99d1e92",
  null
  
)

export default component.exports